// --------------------------------------------------------------------------
// #34 – Membership form
//     - handles entering and validating addresses for all address fields
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var events = require('common-js-pub-sub')();
var debounce = require('../utilities/debounce');

// jquery plugins
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');
require('../plugins/expressive.annotations.validate');

module.exports = function (options) {
    var context = options.context;
    var subscribeScrollToElement, subscribeUpdateAddress;

    var addressHTML = {
        fieldGroup: $('<div class="field-group"/>'),
        nonEdittableAddress: $('<div class="non-edittable-address" aria-live="alert" />'),
        editAddressButton: $('<button class="edit-selected-address" data-binding="edit-selected-address-button" type="button">Edit</button>')
    };

    function createBillingAddress() {
        context.find('[data-binding="edit-address-fields"]').before(addressHTML.fieldGroup);
        addressHTML.fieldGroup.hide().append(addressHTML.nonEdittableAddress);
    }

    function updateSchoolAddress() {
        if ($('[data-binding="school-address"]').length) {
            $('[data-binding="school-address"]').trigger('address-updated');
        }
    }

    /**
     * Updates the hidden address fields passed to Authorize.Net
     */
    function updateBillingAddress(line1, line2, line3, town, county, postcode, country) {

        var hiddenAddress = $('#x_address');
        var hiddenTown = $('#x_city');
        var hiddenCounty = $('#x_state');
        var hiddenPostcode = $('#x_zip');
        var hiddenCountry = $('#x_country');
        var hiddenBillingAddress = $('#DifferentBillingAddress');

        if (hiddenAddress.length > 0) {
            var address = line1;
            if (line2 !== '') {
                address += ', ' + line2;
            }
            if (line3 !== '') {
                address += ', ' + line3;
            }

            if (county === '') {
                county = town;
            }

            hiddenAddress.val(address);
            hiddenTown.val(town);
            hiddenCounty.val(county);
            hiddenPostcode.val(postcode);
            hiddenCountry.val(country);
            hiddenBillingAddress.val(true);
        }
    }

    /**
     * Returns a pubsub subscribe function for listening for when an address field is updated
     * The object passed may contain an array of address parts as simple strings (from the selection following a post-code look-up,
     * or an array of form fields (from the manual entry).  The 'fromSelection' boolean field is used to distinguish.
     * @return { pubsub.subscribe } a pubsub subscribe function
     */
    function subscribeUpdateAddressFn() {
        return events.subscribe('update-address-fields', function (obj) {
            var address = obj.address;

            if (!obj.fromSelection) {
                context.find('.non-edittable-address').empty();

                $.each(address, function (index, value) {

                    context.find('.use-this-address').after(addressHTML.fieldGroup);
                    context.find('.non-edittable-address').append('<div class="address-row">' + $(value).val() + '</div>', addressHTML.editAddressButton);

                    $('.address-part-' + (index + 1)).val($(value).val());
                });
                updateSchoolAddress();
            }

            function formatAddressLine(line) {
                if (obj.fromSelection) {
                    return address[line];
                } else {
                    return address[line] && address[line].value ? address[line].value : '';
                }
            }

            updateBillingAddress(formatAddressLine(0), formatAddressLine(1), formatAddressLine(2), formatAddressLine(3), formatAddressLine(4), formatAddressLine(5), formatAddressLine(6));
        });
    }

    function subscribeScrollToElementFn() {
        return events.subscribe('scroll-to-element', function (obj) {
            $('html, body').animate({
                scrollTop: obj.offsetTop
            }, 500);
        });
    }

    function init() {

        subscribeScrollToElement = subscribeScrollToElementFn();
        subscribeUpdateAddress = subscribeUpdateAddressFn();

        createBillingAddress();

        // Display all address fields and scroll to
        context.on('click', '[data-binding="outside-uk-button"], [data-binding="enter-address-manually"]', function (e) {
            e.preventDefault();

            var editAddressFields = context.find('[data-binding="edit-address-fields"]');

            editAddressFields.slideDown(function () {
                var offsetTop = editAddressFields.offset().top;
                events.publish('scroll-to-element', {
                    offsetTop: offsetTop
                });
                context.find('[data-binding="address-part-street-address"]:eq(0)').focus();
            });
        });

        // look up address button click handler
        context.on('click', '[data-binding="find-address-button"]', function (e) {
            e.preventDefault();

            var addressLoading = $('.address-loading');
            addressLoading.show();

            var form = context.find('form');
            var currentUrl = context.find('#CurrentPageUrl');

            var postcodeField = form.find('[data-binding="postcode-lookup-input-field"]');
            var postcodeFieldValid = form.validate().element(postcodeField);
            var errorMessage = postcodeField.data('error-message');

            if (postcodeFieldValid) {

                if (postcodeField.val() === '') {
                    var errorSpan = $(this).siblings('.inline').find('span');
                    errorSpan.removeClass('field-validation-valid').addClass('field-validation-error').text(errorMessage);
                    events.publish('scroll-to-error');
                    addressLoading.hide();
                } else {
                    $.ajax({
                        data: form.serialize() + '&' + $(this).attr('name') + '=',
                        type: 'POST',
                        url: !currentUrl || 0 === currentUrl.length ? form.attr('action') : currentUrl.val()
                    }).done(function (data) {
                        context.find('.address-lookup').empty().append(data);
                        createBillingAddress();
                        $.validator.unobtrusive.parse(form);
                    }).fail(function (xhr, textStatus) {
                        // if the back-end service fails, automatically enable manually entering the address
                        context.find('[data-binding="enter-address-manually"]').trigger('click');
                        // display message to enter the address manually
                        context.find('[data-binding="address-part-street-address"]:eq(0)').after('<span class="address-manual-instruction">Please enter your address manually</span>');
                        // remove the message afterwards
                        setTimeout(function () {
                            context.find(".address-manual-instruction").fadeOut(2500);
                        }, 7500);
                    }).always(function () {
                        addressLoading.hide();
                    });
                }
            } else {
                if (postcodeField.val() === '') {
                    $(this).siblings('span').removeClass('field-validation-valid').addClass('field-validation-error').text(errorMessage);
                }

                events.publish('scroll-to-error');
            }
        });

        // edit address display
        context.on('click', '[data-binding="edit-selected-address-button"]', function (e) {
            e.preventDefault();
            context.find('[data-binding="edit-address-fields"]').slideDown();
        });

        // edit address display
        context.on('click', '[data-binding="edit-selected-address-button"]', function (e) {
            e.preventDefault();
            context.find('[data-binding="edit-address-fields"]').slideDown();
        });

        // put full address in place
        context.on('change', '[data-binding="address-select-dropdown"]', function (e) {
            e.preventDefault();

            var fullAddress = $(this).find(':selected').data('fullAddress');
            fullAddress = fullAddress.split(';');

            addressHTML.nonEdittableAddress.empty();

            $.each(fullAddress, function (index, item) {
                addressHTML.nonEdittableAddress.append('<div class="addres-row">' + item + '</div>');
                $('.address-part-' + (index + 1)).val(item).change();
            });

            addressHTML.fieldGroup.show().append(addressHTML.nonEdittableAddress);

            context.find('.use-this-address').after(addressHTML.fieldGroup);
            context.find('.non-edittable-address').append(addressHTML.editAddressButton);

            // reset DbAddressId to Guid.Empty to signify new address
            context.find('input[name="Address.DbAddressId"]').val('00000000-0000-0000-0000-000000000000');

            events.publish('update-address-fields', {
                address: $('[data-binding*="address-part"]')
            });
        });

        context.on('keyup', '[data-binding="address-part-street-address"], [data-binding="address-part-town"], [data-binding="address-part-county"], [data-binding="address-part-postcode"]', debounce(function () {
            events.publish('update-address-fields', {
                address: $('[data-binding*="address-part"]')
            });
        }, 2000));

        context.on('change', '[data-binding="address-part-country"]', function () {
            events.publish('update-address-fields', {
                address: $('[data-binding*="address-part"]')
            });
        });

        context.on('change', '[data-binding="address-select-dropdown"]', function () {
            var addressParts = $('option:selected', $(this)).attr('data-full-address').split(';');
            addressParts.push('United Kingdom');

            events.publish('update-address-fields', {
                address: addressParts,
                fromSelection: true
            });
        });

        // Do we have an address?
        if (context.data('prop') === 'init-address-in-edit' && context.find('[data-binding="edit-address-fields"]').hasClass('edit-address-fields--has-address')) {
            // Show container of the editable address
            addressHTML.fieldGroup.show();

            // Hide full address
            context.find('[data-binding="edit-address-fields"]').hide();

            // Update the editiable address
            events.publish('update-address-fields', {
                address: $('[data-binding*="address-part"]')
            });
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/form-address.js
// module id = 93
// module chunks = 0